export const CameraIcon = ({ color = "#f97316" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 64 64"
  >
    <circle cx="32" cy="32" r="30" fill="white" stroke={color} strokeWidth="3" />

    <g transform="translate(32 32) scale(2, 1.7) translate(-32 -32)">
      <path
        d="M32 24
           c.83 0 1.58.5 1.9 1.28l.3.72h2.8
           c.83 0 1.5.67 1.5 1.5v10
           c0 .83-.67 1.5-1.5 1.5h-9.6
           c-.83 0-1.5-.67-1.5-1.5v-10
           c0-.83.67-1.5 1.5-1.5h2.8l.3-.72
           A2 2 0 0 1 32 24z"
        fill={color}
      />
      <circle cx="32" cy="32" r="4" fill="white" stroke={color} strokeWidth="2" />
    </g>
  </svg>
);